import { Tabs, TabsContent, TabsList, TabsTrigger } from "@/components/ui/tabs";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Textarea } from "@/components/ui/textarea";
import { SUPPORTED_LANGUAGES, DEFAULT_LANGUAGE } from "@/config/languages";
import { useEffect, useState } from "react";

interface TranslatableInputProps {
    label: string;
    value: any; // string | Record<string, string>
    onChange: (value: any) => void;
    component?: 'input' | 'textarea';
    className?: string;
    placeholder?: string;
}

export function TranslatableInput({ label, value, onChange, component = 'input', className, placeholder }: TranslatableInputProps) {
    const [internalValue, setInternalValue] = useState<Record<string, string>>({});

    useEffect(() => {
        // Normalize value to object
        if (typeof value === 'string') {
            setInternalValue({ [DEFAULT_LANGUAGE]: value });
        } else if (value && typeof value === 'object') {
            setInternalValue(value);
        } else {
            setInternalValue({});
        }
    }, [value]);

    const handleChange = (lang: string, newValue: string) => {
        const updated = { ...internalValue, [lang]: newValue };
        setInternalValue(updated);
        onChange(updated);
    };

    const Component = component === 'textarea' ? Textarea : Input;

    return (
        <div className={`space-y-2 ${className}`}>
            <Label>{label}</Label>
            <Tabs defaultValue={DEFAULT_LANGUAGE} className="w-full">
                <TabsList className="mb-2 flex flex-wrap h-auto">
                    {SUPPORTED_LANGUAGES.map((lang) => (
                        <TabsTrigger key={lang.code} value={lang.code} className="text-xs px-2 py-1 h-7">
                            <span className="mr-1">{lang.icon}</span> {lang.code.toUpperCase()}
                        </TabsTrigger>
                    ))}
                </TabsList>
                {SUPPORTED_LANGUAGES.map((lang) => (
                    <TabsContent key={lang.code} value={lang.code}>
                        <Component
                            value={internalValue[lang.code] || ''}
                            onChange={(e) => handleChange(lang.code, e.target.value)}
                            placeholder={`Enter ${label} in ${lang.name}`}
                        />
                    </TabsContent>
                ))}
            </Tabs>
        </div>
    );
}
